import React, { FC, SyntheticEvent } from "react";
import { Button, FormControl, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./BuildHistoryDateRangePicker.module.scss";

interface Props {
    startDate: string;
    endDate: string;
    onChange: (start: string, end: string) => void;
}

export const BuildHistoryDateRangePicker: FC<Props> = ({
    startDate,
    endDate,
    onChange
}) => {
    const handleStart = (e: SyntheticEvent) => {
        const value = (e.currentTarget as HTMLInputElement).value;
        onChange(value, endDate);
    };

    const handleEnd = (e: SyntheticEvent) => {
        const value = (e.currentTarget as HTMLInputElement).value;
        onChange(startDate, value);
    };

    return (
        <div className="d-flex align-items-center">
            <OverlayTrigger
                placement="top"
                delay={{ show: 550, hide: 100 }}
                overlay={
                    <Tooltip id="history-start-date-tooltip">
                        Filter from date
                    </Tooltip>
                }
            >
                <FormControl
                    className={styles.dateInput}
                    type="date"
                    value={startDate}
                    onInput={handleStart}
                    onChange={() => {}}
                    max={endDate || undefined}
                    size="sm"
                />
            </OverlayTrigger>
            <div className="mx-1 text-muted">→</div>
            <OverlayTrigger
                placement="top"
                delay={{ show: 550, hide: 100 }}
                overlay={
                    <Tooltip id="history-end-date-tooltip">
                        Filter to date
                    </Tooltip>
                }
            >
                <FormControl
                    className={styles.dateInput}
                    type="date"
                    value={endDate}
                    onInput={handleEnd}
                    onChange={() => {}}
                    min={startDate || undefined}
                    size="sm"
                />
            </OverlayTrigger>
            <Button
                variant="outline-secondary"
                size="sm"
                className="ms-1 text-muted"
                disabled={!startDate && !endDate}
                onClick={() => onChange("", "")}
            >
                <FontAwesomeIcon icon={faXmark} size="lg" />
            </Button>
        </div>
    );
};
